const { FormControl } = window.od;

class RecaptchaFormControl extends FormControl {
	onSubmit(e) {
		if (!this.validateForm()) {
			e.preventDefault();
		} else if (this.checkRecaptcha()) {
			e.preventDefault();
			window.grecaptcha.execute();
		}
	}

	checkRecaptcha() {
		return this.form.getElementsByClassName('g-recaptcha').length > 0;
	}
}

export default RecaptchaFormControl;
